var address_id_map = {
    'mypage': {
        // keyはマッチするアドレス valueはnavLinkのid
        '': 'mypage',
        'profile': 'profile',
        'order-history': 'order-history',
        'inquiry': 'inquiry'
    },
    'back-office': {
        '': 'back-office',
        'order-support': 'order-support',
        'products': 'products',
        'stocker': 'stocker',
        'blogger': 'blogger',
        'manage': 'manage',
    }
}

var pathArr = location.pathname.split('/');
window.onload = () => {
    const sidenav = document.getElementById("sidenav")
    if (sidenav) {
        var sidenav_menus = Array.from(sidenav.querySelectorAll(".nav-link"));
        // 初期化
        sidenav_menus.forEach(element => {
            element.classList.remove('active');
        });
    }

    if (pathArr[1] != 'accounts') {
        var menu_bar_dict = address_id_map[pathArr[1]];
        var nav_id = `navLink-${menu_bar_dict[pathArr[2]]}`;
        // nav menu に色付け
        const navEl = document.getElementById(nav_id)
        navEl?.classList.add('active');
    }
}


